import { round } from "./value-formatter";

export const bigNumberFormatter = (value) => {
    if (value > 1_000_000) return `${round(value / 1_000_000, 1)}M`;
    if (value > 100_000) return `${round(value / 1_000, 0)}K`;
    if (value > 1_000) return `${round(value / 1_000, 1)}K`;
    return value;
};

export const intlNumberFormatter = (value, decimals = 2) => {
    const locale = "en-GB";
    // try {
    //     locale = Intl.DateTimeFormat().resolvedOptions().locale;
    // } catch (e) {
    //     return value;
    // }
    try {
        const formatter = new Intl.NumberFormat(locale, {
            style: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: decimals,
        });
        return formatter.format(value);
    } catch (e) {
        return value;
    }
};
